import React from 'react'

interface PrimaryButtonProps {
  children: React.ReactNode
  onClick?: () => void
  icon?: React.ReactNode
  type?: 'button' | 'submit'
  disabled?: boolean
}

const PrimaryButton = ({
  children,
  onClick,
  icon,
  type = 'button',
  disabled = false
}: PrimaryButtonProps): JSX.Element => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className="px-3 py-2 bg-Estigroup-primary rounded-md flex justify-center items-center gap-1.5 overflow-hidden disabled:opacity-50 disabled:cursor-not-allowed"
      style={{
        boxShadow:
          '0px 0px 0px 1px rgba(53,130,206,1.00), 0px 1px 2px 0px rgba(0,89,138,1.00), inset 0px 0.75px 0px 0px rgba(255,255,255,0.20)'
      }}>
      {icon}
      <div className="text-buttons-text-primary text-sm font-semibold font-Montserrat leading-5">{children}</div>
    </button>
  )
}

export default PrimaryButton
